module.exports = __webpack_public_path__ + "static/florista-8a08b66142eee71e9152d777ce49c679.png";